import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import InfoBox from './InfoBox';
import './OverviewMapBuildings.scss';

const OverviewMapBuildings = ({ title, text, areas }) => {
    const [activeArea, setActiveArea] = useState(null);
    const [activeMarker, setActiveMarker] = useState(null);
    const [boxPosition, setBoxPosition] = useState([0, 0]);
    const [boxAlignment, setBoxAlignment] = useState('left');
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    const defaultOpacity = 0;
    const activeMakerZoom = dimensions.width > 1150 ? 1 : 1.6;
    const defaultMarkerZoom = dimensions.width > 1150 ? 0.85 : 1.4;

    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    });

    function debounce(fn, ms) {
        let timer;
        return () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                fn.apply(this, arguments);
            }, ms);
        };
    }

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }, 1000);
        window.addEventListener('resize', debouncedHandleResize);
        return () => {
            window.removeEventListener('resize', debouncedHandleResize);
        };
    });

    const areaStyle = {
        fill: 'none',
        stroke: '#e44881',
        strokeOpacity: 1,
        strokeWidth: dimensions.width > 1150 ? 6 : 12,
        strokeDasharray: 20,
        opacity: defaultOpacity,
        transition: 'opacity 0.3s linear',
        animation: 'areaDash 20s linear infinite',
    };

    const markerStyle = {
        filter: 'drop-shadow(10px -5px 5px rgba(0, 0, 0, 0.3))',
        strokeWidth: 0,
        cursor: 'pointer',
        transition: 'all 0.3s',
    };

    const markerClick = (id, position = '', alignment) => {
        setActiveArea(null);
        setTimeout(() => {
            setActiveArea(id);
            setActiveMarker(id);
        }, 100);
        setBoxPosition(position);
        setBoxAlignment(alignment);
    };

    return (
        <div className="OverviewMapBuildings" ref={ref}>
            <h2 className="OverviewMapBuildings__Title">{title}</h2>
            {text && <p className="OverviewMapBuildings__Text">{text}</p>}
            <div className="OverviewMapBuildings__Content">
                <div className="OverviewMapBuildings__MapContainer">
                    <div className="OverviewMapBuildings__Map" />
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="svg2"
                        viewBox="0 0 1312 937">

                        <g
                            style={{opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(-50vh)', transition: 'transform 0.4s cubic-bezier(0.175, 0.1, 0.32, 1.275)'}}
                        >


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,445.13095,220.53571)"
                                id="g547">
                                <g
                                    id="g545"
                                    onClick={() => markerClick(0, ['13%', '50%'])}
                                    onMouseOver={() => setActiveMarker(0)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 0
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}>
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                        id="path541" />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                        id="path543" />
                                </g>
                            </g>





                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,292.47617,287.69049)"
                            >
                                <g
                                    onClick={() => markerClick(1, ['37%', '37%'])}
                                    onMouseOver={() => setActiveMarker(1)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                        activeMarker === 1
                                            ? `scale(${activeMakerZoom})`
                                            : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>
                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,396.79761,445.46426)"
                            >
                                <g
                                    onClick={() => markerClick(2, ['47%', '37%'])}
                                    onMouseOver={() => setActiveMarker(2)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                        activeMarker === 2
                                            ? `scale(${activeMakerZoom})`
                                            : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>
                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,564.45831,723.45831)"
                            >
                                <g
                                    onClick={() => markerClick(3, ['70%', '15%'], 'right')}
                                    onMouseOver={() => setActiveMarker(3)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                        activeMarker === 3
                                            ? `scale(${activeMakerZoom})`
                                            : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>
                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,422.67264,672.10712)"
                            >
                                <g
                                    onClick={() => markerClick(4, ['70%', '13%'])}
                                    onMouseOver={() => setActiveMarker(4)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                        activeMarker === 4
                                            ? `scale(${activeMakerZoom})`
                                            : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                        id="path1031-0-2"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>
                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,389.92261,707.1964)"
                            >
                                <g
                                    onClick={() => markerClick(5, ['70%', '29%'], 'right')}
                                    onMouseOver={() => setActiveMarker(5)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                        activeMarker === 5
                                            ? `scale(${activeMakerZoom})`
                                            : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>





                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,242.31546,704.97614)"
                            >
                                <g
                                    onClick={() => markerClick(6, ['78%', '40%'], 'right')}
                                    onMouseOver={() => setActiveMarker(6)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 6
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,379.8988,816.32141)"
                            >
                                <g
                                    onClick={() => markerClick(7, ['83%', '32%'], 'right')}
                                    onMouseOver={() => setActiveMarker(7)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 7
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,612.6131,652.47021)"
                            >
                                <g
                                    onClick={() => markerClick(8, ['68%', '58%'], 'right')}
                                    onMouseOver={() => setActiveMarker(8)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 8
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,677.16077,427.17859)"
                            >
                                <g
                                    onClick={() => markerClick(9, ['42%', '58%'], 'right')}
                                    onMouseOver={() => setActiveMarker(9)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 9
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,783.52979,423.7381)"
                            >
                                <g
                                    onClick={() => markerClick(10, ['48%', '53%'], 'right')}
                                    onMouseOver={() => setActiveMarker(10)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 10
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,733.1012,453.46429)"
                            >
                                <g
                                    onClick={() => markerClick(11, ['48%', '53%'], 'right')}
                                    onMouseOver={() => setActiveMarker(11)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 11
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,872.11902,633.4881)"
                            >
                                <g
                                    onClick={() => markerClick(12, ['63%', '38%'], 'right')}
                                    onMouseOver={() => setActiveMarker(12)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 12
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,816.25592,618.79761)"
                            >
                                <g
                                    onClick={() => markerClick(13, ['68%', '48%'], 'right')}
                                    onMouseOver={() => setActiveMarker(13)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 13
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,778.28571,671.17859)"
                            >
                                <g
                                    onClick={() => markerClick(14, ['68%', '50%'], 'right')}
                                    onMouseOver={() => setActiveMarker(14)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 14
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,882.11902,779.4881)"
                            >
                                <g
                                    onClick={() => markerClick(15, ['82%', '38%'], 'right')}
                                    onMouseOver={() => setActiveMarker(15)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 15
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,960.6369,711.69647)"
                            >
                                <g
                                    onClick={() => markerClick(16, ['78%', '33%'], 'right')}
                                    onMouseOver={() => setActiveMarker(16)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 16
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,1044.4882,629.125)"
                            >
                                <g
                                    onClick={() => markerClick(17, ['68%', '33%'], 'right')}
                                    onMouseOver={() => setActiveMarker(17)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 17
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,1169.3512,617.29169)"
                            >
                                <g
                                    onClick={() => markerClick(18, ['63%', '20%'], 'right')}
                                    onMouseOver={() => setActiveMarker(18)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 18
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,1000.4882,549.125)"
                            >
                                <g
                                    onClick={() => markerClick(19, ['58%', '28%'], 'right')}
                                    onMouseOver={() => setActiveMarker(19)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 19
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>



                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,1110.3214,308.32144)"
                            >
                                <g
                                    onClick={() => markerClick(20, ['33%', '28%'], 'right')}
                                    onMouseOver={() => setActiveMarker(20)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 20
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,796.67261,285.81546)"
                            >
                                <g
                                    onClick={() => markerClick(21, ['33%', '48%'], 'right')}
                                    onMouseOver={() => setActiveMarker(21)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 21
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,649.70239,132.4762)"
                            >
                                <g
                                    onClick={() => markerClick(22, ['14%', '58%'], 'right')}
                                    onMouseOver={() => setActiveMarker(22)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 22
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,687.59521,270.28571)"
                            >
                                <g
                                    onClick={() => markerClick(23, ['28%', '53%'], 'right')}
                                    onMouseOver={() => setActiveMarker(23)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 23
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,663.6012,212.75595)"
                            >
                                <g
                                    onClick={() => markerClick(24, ['23%', '53%'], 'right')}
                                    onMouseOver={() => setActiveMarker(24)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 24
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>

                            <g
                                transform="matrix(0.67242063,0,0,0.65243569,499.33929,119.33334)"
                            >
                                <g
                                    onClick={() => markerClick(25, ['10%', '66%'], 'right')}
                                    onMouseOver={() => setActiveMarker(25)}
                                    onMouseOut={() => setActiveMarker(activeArea)}
                                    style={{
                                        ...markerStyle,
                                        transform:
                                            activeMarker === 25
                                                ? `scale(${activeMakerZoom})`
                                                : `scale(${defaultMarkerZoom})`,
                                    }}
                                >
                                    <path
                                        fill="#00797b"
                                        d="M 24.828832,80.56573 C 18.057332,62.494912 0,43.499471 0,31.247456 0,14.116322 15.943119,0 33.059965,0 50.181326,0 60,20.243835 60,37.374969 c 0,6.616931 -7.51185,14.85873 -12.79061,23.341474 -4.484238,7.207244 -7.543451,8.917947 -10.533444,18.070818 -0.887819,2.718152 -2.741705,5.341432 -4.190806,7.113878 -1.106011,1.353806 -3.035136,1.501383 -4.193815,0.192756 -1.092469,-1.23484 -2.40313,-3.053968 -3.460989,-5.526659 z"
                                    />
                                    <path
                                        fill="#99c7c2"
                                        d="m 32.04424,51.146438 c -9.191182,0 -18.692348,-8.753804 -18.692348,-18.048229 0,-9.294423 8.777368,-16.585999 17.967046,-16.585999 2.690542,0 5.712136,1.049613 7.960273,2.195604 4.582048,0.487913 8.682568,8.059584 8.682568,14.63435 0,9.295931 -6.726357,17.805781 -15.917539,17.805781 z"
                                    />
                                </g>
                            </g>


                        </g>
                    </svg>
                </div>
                {activeArea !== null && (
                    <InfoBox
                        setActiveArea={setActiveArea}
                        position={boxPosition}
                        alignment={boxAlignment}
                        windowWidth={dimensions.width}
                        {...areas[activeArea]}
                    />
                )}
            </div>
        </div>
    );
};

OverviewMapBuildings.propTypes = {
    title: PropTypes.string,
    areas: PropTypes.array,
};

OverviewMapBuildings.defaultProps = {};

export default OverviewMapBuildings;
